<template>
  <div class="doorder-register doorder-auth-container h-100">
    <b-navbar variant="faded" type="light" fixed="top">
      <b-navbar-brand href="" class="p-0">
        <img
          src="@/assets/images/doorder/doorder-logo.png"
          class="d-inline-block align-top"
          alt="Doorder"
        />
      </b-navbar-brand>
    </b-navbar>
    <div class="main-panel main-panel-auth-doorder w-100">
      <div class="content content-register">
        <div class="h-100">
          <b-row class="h-100 m-0">
            <b-col xl="4" lg="4" md="4" class="">
              <div class="tabs-ul-doorder-container">
                <h6 class="welecomeH6 welcomeDoorderH6 mt-4">
                  Retailer Registration Form
                </h6>
                <p class="welcomeP welcomeDoorderP">
                  Sign up and partner with DoOrder Today
                </p>
                <!-- <form-wizard   shape="tab" color="purple">
            <tab-content title="Personal details">
              My first tab content
            </tab-content>
            <tab-content title="Additional Info">
              My second tab content
            </tab-content>
            <tab-content title="Last step">
              Yuhuuu! This seems pretty damn simple
            </tab-content>
          </form-wizard> -->
                <ul
                  v-scroll-spy-active
                  v-scroll-spy-link
                  class="register-tabs-doorder-ul mt-md-5 mt-1"
                >
                  <li>
                    <a> Company Details</a>
                  </li>
                  <li>
                    <a> Location Details</a>
                  </li>
                  <li>
                    <a> Contact Details</a>
                  </li>
                  <li>
                    <a> Payment Details</a>
                  </li>
                </ul>
              </div>
            </b-col>
            <b-col xl="8" lg="8" md="8">
              <b-form @submit.prevent="onSubmit" ref="retailerRegisterForm">
                <input type="hidden" name="client" v-model="client_name" />
                <b-card no-body class="mt-0">
                  <b-card-body class="p-0">
                    <div v-scroll-spy="{ offset: 100 }">
                      <div>
                        <CompanyDetails
                          type="register"
                          :company_name.sync="company_name"
                          :company_website.sync="company_website"
                          :business_type.sync="business_type"
                          :number_business_locations.sync="
                            number_business_locations
                          "
                        />
                      </div>
                      <div>
                        <LocationDetails
                          type="register"
                          :locations.sync="locations"
                        />
                      </div>
                      <div>
                        <ContactDetails
                          type="register"
                          :locations="locations"
                          :contacts.sync="contacts"
                          :contacts_locations = "contacts_locations"
                        />
                      </div>
                      <div>
                        <PaymentDetails
                          ref="payment_details"
                          type="register"
                          :require_card.sync="require_card"
                          :stripe_token.sync="stripe_token"
                        />
                      </div>
                    </div>
                    <b-card
                      no-body
                      class="card-transparent-background mt-1 mb-3"
                    >
                      <b-card-body class="py-0">
                        <b-row>
                          <b-col class="terms-container-doorder">
                            By clicking 'Submit', I hereby acknowledge and agree
                            that I have read and understood
                            <a
                              href="https://44fc5dd5-ecb5-4c2e-bb94-31bcbc8408a1.filesusr.com/ugd/0b2e42_1b6020943d804795becb839f2c103421.pdf"
                              target="_blank"
                              >DoOrder's Privacy Policy</a
                            >. DoOrder uses Cookies to personalise your
                            experience. For DoOrder's full Cookies Policy,
                            please
                            <a
                              href="https://44fc5dd5-ecb5-4c2e-bb94-31bcbc8408a1.filesusr.com/ugd/0b2e42_64b44367a7ab4471b94569c71c610c6e.pdf"
                              target="_blank"
                              >click here</a
                            >.
                          </b-col>
                        </b-row>
                      </b-card-body>
                    </b-card></b-card-body
                  >
                </b-card>

                <b-row class="my-4">
                  <b-col lg="4" md="6" class="mx-auto">
                    <b-button
                      type="submit"
                      variant="doorder-primary"
                      class="
                        btn btn-bumblebee btn-doorder btn-submit-register
                        mx-auto
                      "
                      v-if="!is_loading"
                      >Submit</b-button
                    >
                    <b-button
                      type="button"
                      disabled
                      variant="doorder-primary"
                      class="
                        btn btn-bumblebee btn-doorder btn-submit-register
                        mx-auto
                      "
                      v-else
                    >
                      <b-spinner
                        small
                        label="Small Spinner"
                        variant="light"
                      ></b-spinner>
                      Loading</b-button
                    >
                  </b-col>
                </b-row>
              </b-form>
            </b-col>
          </b-row>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { FormWizard, TabContent } from "vue-form-wizard";
import "vue-form-wizard/dist/vue-form-wizard.min.css";
import Vue from "vue";
import Scrollspy from "vue2-scrollspy";
// use default options
Vue.use(Scrollspy);

import CompanyDetails from "../profile_details_components/CompanyDetails.vue";
import LocationDetails from "../profile_details_components/LocationDetails.vue";
import ContactDetails from "../profile_details_components/ContactDetails.vue";
import PaymentDetails from "../profile_details_components/PaymentDetails.vue";

import axios from "axios";

export default {
  name: "DoOrderRetailerRegistration",
  components: {
    FormWizard,
    TabContent,
    CompanyDetails,
    LocationDetails,
    ContactDetails,
    PaymentDetails,
  },
  data() {
    return {
      client_name: "DOORDER",
      type: "retailer",
      //company details
      company_name: null,
      company_website: null,
      business_type: null,
      number_business_locations: null,
      //locations details
      locations: [
        {
          address: "",
          post_code: "",
          latitude: "",
          longitude: "",
          country: "",
          county: "",
          business_hours: "",
          business_hours_json: "",
          invalid_country: false,
          invalid_county: false,
        },
      ],
      contacts_locations:['Location 1'],
      //contacts details
      contacts: [
        {
          name: "",
          phone: "",
          email: "",
          location: null,
          invalid_phone_number: false,
          invalid_location: false,
        },
      ],
      // payment details
      require_card: false,
      stripe_token: null,
      // request api data
      user_id: null,

      is_loading: false,
    };
  },
  updated() {
    console.log("updated")
  },
  watch:{
    locations(newLocs, oldLocs){
      console.log("watch ")
      console.log(newLocs.length)
      console.log(oldLocs.length)
      this.contacts_locations = []
      for(var i=0; i<newLocs.length; i++){
        this.contacts_locations.push("Location "+(i+1))
      }
      console.log(this.contacts_locations)
    }
  },
  mounted(){
    console.log(this.contacts)
  },
  methods: {
    // Convenience method to scroll a heading into view.
    // Not required for scrollspy to work
    scrollIntoView(event) {
      event.preventDefault();
      const href = event.target.getAttribute("href");
      const el = href ? document.querySelector(href) : null;
      if (el) {
        this.$refs.content.scrollTop = el.offsetTop;
      }
    },
    async onSubmit() {
      this.stripe_token = null;
      this.is_loading = true;
      console.log("submit signup ", this.client_name, this.require_card);
      console.log(this.locations);
      if (this.require_card == "false" || !this.require_card) {
        let { is_valid_locations, is_valid_contacts } = this.checkValidation();
        console.log(is_valid_locations, is_valid_contacts);
        console.log(this.locations);
        console.log(this.contacts);

        if (is_valid_locations && is_valid_contacts) {
          this.sendUserDataRequest();
        } else {
          this.is_loading = false;
        }
      } else {
        console.log(" selected card");

        let { is_valid_locations, is_valid_contacts } = this.checkValidation();
        console.log(is_valid_locations, is_valid_contacts);
        console.log(this.locations);
        console.log(this.contacts);

        if (is_valid_locations && is_valid_contacts) {
          await this.$refs.payment_details.$refs.stripe_component.purchase();
          console.log(this.stripe_token);
          if (this.stripe_token != null) {
            this.sendUserDataRequest();
          } else {
            this.is_loading = false;
          }
        } else {
          this.is_loading = false;
        }
      }
    },
    checkValidation() {
      // check validation
      // location
      var is_valid_locations = true;
      for (var i = 0; i < this.locations.length; i++) {
        let location = this.locations[i];
        if (location.country == null || location.country == "") {
          this.locations[i].invalid_country = true;
          is_valid_locations = false;
        } else {
          this.locations[i].invalid_country = false;
        }
        if (location.county == null || location.county == "") {
          this.locations[i].invalid_county = true;
          is_valid_locations = false;
        } else {
          this.locations[i].invalid_county = false;
        }
      }
      // contact
      let is_valid_contacts = true;
      for (let i = 0; i < this.contacts.length; i++) {
        let contact = this.contacts[i];
        if (contact.phone == null || contact.phone == "") {
          this.contacts[i].invalid_phone_number = true;
          is_valid_contacts = false;
        } else {
          this.contacts[i].invalid_phone_number = false;
        }
        if (contact.location == null || contact.location == "") {
          this.contacts[i].invalid_location = true;
          is_valid_contacts = false;
        } else {
          this.contacts[i].invalid_location = false;
        }
      }
      return { is_valid_locations, is_valid_contacts };
    },
    sendUserDataRequest() {
      console.log("in send user request ", this.client_name, this.type);
      console.log(this.company_name);
      console.log(
        this.contacts[0].phone,
        this.contacts[0].email,
        this.makeRandomText(6)
      );
      this.is_loading = true;
      let formData = new FormData();
      formData.append("client", this.client_name);
      formData.append("type", this.type);
      formData.append("name", this.company_name);
      formData.append("phone", this.contacts[0].phone);
      formData.append("email", this.contacts[0].email);
      formData.append("password", this.makeRandomText(6));

      axios
        .post("user/register", formData, {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            "Content-Type": "application/x-www-form-urlencoded",
          },
        })
        .then((response) => {
          console.log(response);
          this.user_id = response.data.id;
          this.sendRetailerDataRequest();
          // this.$fire({
          //   // title: "Title",
          //   text: "Class is created successfully",
          //   type: "success",
          //   timer: 3000,
          // }).then((r) => {
          //   // console.log(r.value);
          // });
          // this.is_loading = false;
          // this.$router.go();
        })
        .catch((error) => {
          console.log(error.response);
          this.is_loading = false;
          this.$fire({
            // title: "Title",
            text: error.response.data.error,
            type: "error",
            customClass: {
              container: "swal-alert-doorder",
              confirmButton:
                "btn btn-bumblebee btn-doorder btn-doorder-primary btn-doorder-submit",
              cancelButton:
                "btn btn-bumblebee btn-doorder btn-doorder-danger-outline btn-doorder-submit",
            },
            // timer: 3000,
          }).then((r) => {
            // console.log(r.value);
          });
        });
      // this.user_id = 11;
      // this.sendRetailerDataRequest();
    },
    sendRetailerDataRequest() {
      console.log("in send retailer request ", this.client_name, this.user_id);
      console.log("company details");
      console.log(
        this.company_name,
        this.company_website,
        this.business_type,
        this.number_business_locations
      );
      console.log("locations details");
      for (var i = 0; i < this.locations.length; i++) {
        console.log(this.locations[i]);
      }
      console.log("contacts details");
      for (var i = 0; i < this.contacts.length; i++) {
        console.log(this.contacts[i]);
      }
      console.log("payment details");
      console.log(this.require_card);
      let requestData = {
        client: this.client_name,
        user_id: this.user_id,
        company_name: this.company_name,
        company_website: this.company_website,
        business_type: this.business_type,
        number_business_locations: this.number_business_locations,
        contacts: this.contacts,
        locations: this.locations,
        // stripe_token: this.stripe_token,
      };
      console.log(requestData);
      axios
        .post("retailer/register", requestData, {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            client: "DOORDER",
          },
        })
        .then((response) => {
          console.log(response);
          this.$fire({
            // title: "Title",
            text: response.data.message,
            type: "success",
            customClass: {
              container: "swal-alert-doorder",
              confirmButton:
                "btn btn-bumblebee btn-doorder btn-doorder-primary btn-doorder-submit",
              cancelButton:
                "btn btn-bumblebee btn-doorder btn-doorder-danger-outline btn-doorder-submit",
            },
            // timer: 3000,
          }).then((r) => {
            // console.log(r.value);
          });
          this.is_loading = false;
          this.$refs.retailerRegisterForm.reset();
          this.locations = [
            {
              address: "",
              post_code: "",
              latitude: "",
              longitude: "",
              country: "",
              county: "",
              business_hours: "",
              business_hours_json: "",
            },
          ];
          this.contacts = [{ name: "", phone: "", email: "", location: null }];
          // this.$router.go();
        })
        .catch((error) => {
          console.log(error.response);
          this.is_loading = false;
          this.$fire({
            // title: "Title",
            text: error.response.data.error ? error.response.data.error : error.response.data.message,
            type: "error",
            customClass: {
              container: "swal-alert-doorder",
              confirmButton:
                "btn btn-bumblebee btn-doorder btn-doorder-primary btn-doorder-submit",
              cancelButton:
                "btn btn-bumblebee btn-doorder btn-doorder-danger-outline btn-doorder-submit",
            },
            // timer: 3000,
          }).then((r) => {
            // console.log(r.value);
          });
        });
    },

    // testClick() {
    //   console.log("click submit ", this.client_name);
    //   console.log("contacts details");
    //   for (var i = 0; i < this.contacts.length; i++) {
    //     console.log(this.contacts[i]);
    //   }
    // },
    makeRandomText(length) {
      var result = "";
      var characters =
        "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
      var charactersLength = characters.length;
      for (var i = 0; i < length; i++) {
        result += characters.charAt(
          Math.floor(Math.random() * charactersLength)
        );
      }
      return result;
    },
  },
};
</script>

<style  scoped::v-deep>
@import "../../css/doorder-styles.css";
@import "../../css/doorder-auth-styles.css";
@import "../../css/doorder-buttons-styles.css";
</style>



// WEBPACK FOOTER //
// src/components/doorder/retailers/Registration/Index.vue